import { intl } from '../../localization';

export const getTranslationId = (status: string) =>
  `shared.AdvancementFileStatus.${status}`;

export const getTranslation = (status: string) =>
  intl.formatMessage({ id: getTranslationId(status) });
